"use client";
import { useActionState } from "react";
import Input from "../ui/input";
import PrimaryButton from "../ui/primary-button";
import {
  create,
  NewsletterEmailOnlyErrors,
} from "../newsletter-email-only-actions";
import { useEffect } from "react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

const initialState: {
  status: string;
  errors?: NewsletterEmailOnlyErrors;
  message?: string;
} = { status: "" };

const SubmitButton = ({ isPending }: { isPending: boolean }) => {
  return (
    <PrimaryButton
      className=""
      size="md"
      color="teal"
      type="submit"
      aria-label="submit newsletter form input"
      disabled={isPending}
    >
      Sign Up
    </PrimaryButton>
  );
};

export interface NewsletterFormSmallProps {
  heading?: string;
  className?: string;
}

const NewsletterFormSmall: React.FC<NewsletterFormSmallProps> = ({
  heading = "Sign up for our blog to learn more!",
  className = "",
}) => {
  const [state, formAction, isPending] = useActionState(create, initialState);

  useEffect(() => {
    if (state?.message) {
      toast.error(state?.message);
    }
  }, [state]);

  return (
    <div
      className={cn(
        "grid h-fit w-fit grid-cols-1 gap-2 rounded-3xl border-neutral-200 bg-secondary-100 p-4 shadow-[4px_8px_16px_2px_rgba(0,65,66,0.1)] md:gap-4",
        className
      )}
    >
      <h3 className="font-montserrat text-subheading-3-500 text-neutral-500">
        {heading}
      </h3>
      {state.status === "success" ? (
        <p className="font-robot text-body-1-300 text-neutral-500 md:text-body-1-400">
          Thank you for subscribing to our newsletter!
        </p>
      ) : (
        <form
          id="newsletter-resources-small-form"
          className="flex w-full flex-row items-center gap-2"
          action={formAction}
          aria-label="newsletter form small"
        >
          <Input
            className="flex w-[120px] flex-1"
            type="email"
            variant="border"
            name="email"
            aria-label="email"
            autoComplete="email"
            placeholder="Email Address"
            error={
              Boolean(state.errors?.email?.length) ||
              Boolean(state.errors && Object.keys(state.errors).length > 0)
            }
            required
            errorMessage={
              Boolean(state.errors?.email?.length)
                ? state.errors?.email?.join(", ") || "Email is required"
                : "Email is required"
            }
          />
          <SubmitButton isPending={isPending} />
        </form>
      )}
    </div>
  );
};

export default NewsletterFormSmall;
